import i18n from "i18next";
import { en, ptBr } from "locale/resources";
import { initReactI18next } from "react-i18next";

const resources = {
  en,
  ptBr,
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
